import { ReasonMappingType } from '../../../../services/ConfigurationService/types/centerType';
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Page, Sort, RowSelectEventArgs } from '@syncfusion/ej2-react-grids';
import { Box, Typography } from '@mui/material';

interface ReasonMappingGridProps {
  reasonMappings: ReasonMappingType[];
  onRowSelect?: (mapping: ReasonMappingType) => void;
}

export function ReasonMappingGrid({ reasonMappings, onRowSelect }: ReasonMappingGridProps) {
  // Handle row selection for editing
  const handleRowSelection = (args: RowSelectEventArgs) => {
    // Resolve the grid's own row object back to the mapping the caller passed in, as
    // OutlierConfigGrid does, so the caller holds its object and not the grid's copy
    const selected = args.data as ReasonMappingType | undefined;
    const mapping = reasonMappings.find(m => m.sourceReason === selected?.sourceReason);

    if (mapping && onRowSelect) {
      onRowSelect(mapping);
    }
  };

  if (reasonMappings.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" sx={{ color: '#64748b', mb: 1 }}>
          No reason mappings found
        </Typography>
        <Typography variant="body2" sx={{ color: '#94a3b8' }}>
          No EMR reason mappings set for this center
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <GridComponent
        dataSource={reasonMappings}
        height={400}
        allowPaging={true}
        allowSorting={true}
        pageSettings={{ pageSize: 25 }}
        selectionSettings={{ mode: 'Row', type: 'Single' }}
        rowSelected={handleRowSelection}
        style={{
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          backgroundColor: '#ffffff'
        }}
        enableHover={true}
      >
        <ColumnsDirective>
          <ColumnDirective
            field="sourceReason"
            headerText="Source reason"
            width="300"
            textAlign="Left"
          />
          <ColumnDirective
            field="standardReason"
            headerText="Standard reason"
            width="300"
            textAlign="Left"
          />
        </ColumnsDirective>
        <Inject services={[Page, Sort]} />
      </GridComponent>
    </Box>
  );
}
